export default "<hr>\n<!--\n<div class=\"alert alert-warning\">\n  <strong>Footer</strong>\n</div>\n-->\n"